export default __webpack_public_path__ + "static/media/img3.2b9a263f.jpg";